import { Controller } from "@hotwired/stimulus"
import { createAlert } from '../scripts/createAlert';

export default class extends Controller {
  static targets = [ "input", "quill", "form" ]

  connect() {
    this.syncPhotoUploadRequireImages()
  }

  syncPhotoUploadRequireImages() {
    const photoCheckbox = this.element.querySelector('input[type="checkbox"][name*="has_image_upload"]')
    const requireCheckbox = this.element.querySelector('input[type="checkbox"][name*="require_images"]')
    if (!photoCheckbox || !requireCheckbox) return

    if (photoCheckbox.disabled) return

    const photoEnabled = photoCheckbox.checked

    if (photoEnabled) {
      requireCheckbox.removeAttribute('disabled')
      requireCheckbox.classList.remove('pe-none', 'disabled')
    } else {
      requireCheckbox.disabled = true
      requireCheckbox.classList.add('pe-none', 'disabled')
      requireCheckbox.checked = false
    }
  }

  attemptSubmit(event) {
    event.preventDefault()

    if (!this.hasFormTarget || !this.hasInputTarget || !this.hasQuillTarget) {
      createAlert('danger', 'Unable to validate email template. Please refresh and try again.')
      return
    }

    this.syncEmailTemplateFromEditor()

    var tempElement = document.createElement('body')
    tempElement.innerHTML = this.inputTarget.value
    ;[...tempElement.querySelectorAll('p')].forEach(para => {
      if (para.innerText.trim() === "") tempElement.removeChild(para)
    })
    var text = tempElement.innerHTML

    if (!text || text === "" || text === "<p></p>") {
      this.inputTarget.value = ""
      this.quillTarget.style.setProperty('border', '1px solid #ccc')
      this.formTarget.submit()
      return
    }

    if (!text.includes("{{Link}}") && !text.includes("{{Button}}")) {
      this.quillTarget.style.setProperty('border', '1px solid red', 'important')
      createAlert('danger', 'Email template must contain Button or Link tags')
      return
    }

    this.quillTarget.style.setProperty('border', '1px solid #ccc')
    this.formTarget.submit()
  }

  syncEmailTemplateFromEditor() {
    if (!this.hasInputTarget || !this.hasQuillTarget) return

    // Depending on the Quill build, the editable element can be either:
    // - a descendant with class ".ql-editor", or
    // - the wrapper element itself already having class "ql-editor".
    const editor = this.quillTarget.classList.contains('ql-editor')
      ? this.quillTarget
      : this.quillTarget.querySelector('.ql-editor')

    if (editor) this.inputTarget.value = editor.innerHTML
  }

}
